import { render, staticRenderFns } from "./EventsFeedTab.vue?vue&type=template&id=3a04ce93&scoped=true&"
import script from "./EventsFeedTab.vue?vue&type=script&lang=js&"
export * from "./EventsFeedTab.vue?vue&type=script&lang=js&"
import style0 from "./EventsFeedTab.vue?vue&type=style&index=0&id=3a04ce93&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a04ce93",
  null
  
)

export default component.exports